import { render } from "./PayrollSummery.vue?vue&type=template&id=fcab924e"
import script from "./PayrollSummery.vue?vue&type=script&lang=js"
export * from "./PayrollSummery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__